<template>
  <div class="collectorUpgrade">
    <div class="upgradeInfo">
      <div class="closepage" @click="clickClosepage"></div>
      <div class="xinxi">
        <!-- <div>{{deviceStatus}}</div> -->
        <span class="top-info">
          <span class="label">
            <i class="status-icon-shadow" :class="deviceStatus.class"></i>
          </span>
          <span class="namebox">
            <span class="name">{{ datalogger.alias || datalogger.pn }}</span>
          </span>
        </span>
        <div class="infobox">
          <div class="cell light gCell11 splitHLine">{{ $t('device.device_pn') }}</div>
          <div class="cell light gCell12 splitHLine">{{ $t('datalogger.Datalogger_type') }}</div>
          <div class="cell light gCell13 splitHLine">{{ $t('datalogger.Firmware_Version') }}</div>
          <div class="cell1 light gCell14 splitHLine">{{ $t('datalogger.signal') }}</div>
          <div class="cell data dark gCell21 splitHLine">{{ deviceInfo.pn }}</div>
          <div class="cell data dark gCell22 splitHLine">{{ datalogger.descx }}</div>
          <div class="cell data dark gCell23 splitHLine">{{ datalogger.fireware || '--' }}</div>
          <div class="cell1 data dark gCell24 splitHLine">
            <template slot-scope>
              <signal class="signalNew" :strength="datalogger.signal"></signal>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="infobox1">
      <div class="bTitle1 ">{{ $t('device.device_upgrade1') }}</div>
      <div class="cell light bCell11 splitHLine">{{ $t('device.device_upgradeTime') }}</div>
      <!-- <div class="cell light bCell12 splitHLine">{{$t('device.device_upgradeName')}}</div> -->
      <div class="cell light bCell13 splitHLine">{{ $t('device.device_upgradeStatus') }}</div>
      <div class="cell1 light bCell14 splitHLine">{{ $t('device.device_upgradeProgress') }}</div>
      <div class="cell data dark bCell21 splitHLine">{{ upgradedata.ts || $t('firmware.noRecord') || "--" }}</div>
      <!-- <div class="cell data dark bCell22 splitHLine">{{ datalogger.alias || datalogger.pn }}</div> -->
      <div class="cell data dark bCell23 splitHLine">
        <template slot-scope>
          <div v-if="upgradedata.status == 5">{{ $t('firmware.upgrade_quit5') }}</div>
          <div v-else-if="upgradedata.status == 4">{{ $t('firmware.upgrade_quit6') }}</div>
          <div v-else-if="upgradedata.status == 3" style="color:#30EC70;">{{ $t('firmware.upgrade_quit3') }}</div>
          <div v-else-if="upgradedata.status == 2" style="color:#FF3E3E;">{{ $t('firmware.upgrade_quit7') }}</div>
          <div v-else-if="upgradedata.status == 1" style="color:#EC9630;">{{ $t('firmware.upgrade_quit8') }}</div>
          <div v-else-if="upgradedata.status == 0">{{ $t('firmware.upgrading') }}</div>
          <div v-else>{{ $t('errCode.12') }}</div>
        </template>
      </div>
      <div class="cell1 data dark bCell24 splitHLine">{{ upgradedata.progress || $t('errCode.12') || "--" }}</div>
      <div class="bTitle2 ">{{ $t('device.device_upgradeFirmware') }}
        <button class="todetail" @click="addFirmware()">
          {{ $t('device.Upload1') }}
        </button>
      </div>
    </div>
    <div>
      <el-table style="background:#222D35;color:#fff;" class="tablemain tableloding" v-loading="isLoading"
        element-loading-spinner="el-icon-loading" height="430px" :data="dataTable"
        :header-cell-style="{ background: '#222D35', color: '#ffffff' }" :empty-text="$t('account.nodata')"
        @selection-change="handleSelectionChange" ref="tableRef" :row-style="isRed" :header-cell-class-name="cellClass">
        <el-table-column width="130px" type="index" :label="$t('recharge.serial_number')" header-align="center"
          align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firmware" :label="this.$t('firmware.Firmware_Name')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="this.$t('firmware.Firmware_desrc')" min-width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.desc || '--'">{{ scope.row.desc || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('browse.desc')" min-width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.remark || '--'">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="size" :label="this.$t('firmware.Size')" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="gts" :label="this.$t('firmware.Upload_Time')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="勾选" width="105" type="selection">
        </el-table-column>
      </el-table>
    </div>
    <div class="upgardeButtom">
      <div class="progressBox" v-if="progressUp">
        <el-progress :format="progressText" :percentage="progress" style="width:200px" color="#33FFB6"></el-progress>
      </div>


      <div class="buttonBox">
        <button type="button" class="btn-dark1" @click="submitUpgradeDatalogger">
          <span v-if="buttonUpgrade">{{ $t('datalogger.confirm') }}</span>
          <span v-if="!buttonUpgrade">{{ $t('firmware.upgrading') }}</span>

        </button>
      </div>

    </div>
    <div class="maskBox" v-if="maskBox"></div>
    <firmware-dialog :title="$t('firmware.Upload_firmware')"
      :class="{ 'showDialog': dialogAdd, 'hideDialog': !dialogAdd }" :visible.sync="dialogAdd" width="40vw" noFooter>
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('browse.desc')" size="small">
                <el-input v-model="remark" :placeholder="$t('firmware.enter_content')"></el-input>
              </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="warningTipButton">{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </firmware-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import firmwareDialog from "@/components/dialognew";
import signal from "@/components/signalnew";
export default {
  components: {
    firmwareDialog,
    signal,
  },
  data () {
    return {
      maskBox: false,
      uploadTotalSize: "", //文件的总大小
      uploadNowSize: "0.00", //现在正在上传的大小
      buttonUpgrade: true,
      progress: 0,
      firmwareName: "",
      progressUp: false,
      selectedArrData: [],
      desc: "",
      remark: "",//备注
      upgradedata: {},
      dataTable: [],
      // 增加固件
      dialogAdd: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      datalogger: {},
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    }),
    deviceStatus () {
      return this.$filter.deviceStatusShadow[this.deviceInfo.status];
    },
  },
  created () {
    this.getQueryCollectorFirmwareUpgradeLastRecord()
    this.getQueryFiremware()

  },
  mounted () {
    this.getWebQueryCollectorsEs()
  },
  beforeDestroy() {
    clearInterval(this.interval);// 在组件销毁之前清除定时器
    this.interval = null;
    this.progressUp = false;
  },
  methods: {
    // 确认固件升级
    submitUpgradeDatalogger () {
      this.progress = 0;
      // this.$message.success(this.$t("firmware.upgrading1"));
      if (this.selectedArrData.length == 0) {
        this.$message.error(this.$t("datalogger.file_fist"));
      } else if (this.$store.state.device.status == "1") {
        this.$message.error(this.$t("datalogger.updatefail"));
      } else {
        this.firmwareName = this.selectedArrData[0].id;
        this.uploadTotalSize = this.$filter.formatNum(
          this.selectedArrData.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.$store.state.device.pn,
          firmwareId: this.firmwareName
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/collector/firmwareUpgradeCollector", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              this.buttonUpgrade = false;
              this.maskBox = true;
              // this.$message.success(this.$t("datalogger.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              // this.upgradeDeviceSucVisible = true;
              this.queryProgress();
              // this.upgradeDataloggerVisible = false;
              // this.dialogAdd = false;
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
              // this.dataloggerTipMsg = this.$t("device.System_Failed");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
              // this.dataloggerTipMsg = this.$t("device.Device_Offline");
              // this.upgradeDeviceFailVisible = true;
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
              // this.dataloggerTipMsg = this.$t("device.In_Upgrading");
              // this.upgradeDeviceFailVisible = true;
            }
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
            // this.dataloggerTipMsg = this.$t(`errCode.${res.code}`);
            // this.upgradeDeviceFailVisible = true;
          }
        });
      }
    },
    // 查询升级进度
    queryProgress () {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.$store.state.device.pn,
        // devaddr: this.dataparams.devaddr,
        // devcode: this.dataparams.devcode,
        // sn: this.dataparams.sn,
        key: this.keyProgress
      };
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDataloggerVisible = false;
                    this.maskBox = false;
                    this.buttonUpgrade = true;
                  }, 3000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.progressUp = false;
                this.maskBox = false;
                this.buttonUpgrade = true;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.progressUp = false;
                this.maskBox = false;
                this.buttonUpgrade = true;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.progressUp = false;
                this.maskBox = false;
                this.buttonUpgrade = true;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.progressUp = false;
                this.maskBox = false;
                this.buttonUpgrade = true;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.progressUp = false;
                this.maskBox = false;
                this.buttonUpgrade = true;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
              this.maskBox = false;
              this.buttonUpgrade = true;
            }
          });
      }, 2000);
    },
    //后退
    clickClosepage () {
      this.$store.commit('saveIsShow', 1);
    },
    progressText (progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}`;
    },
    //数采器信息
    getWebQueryCollectorsEs () {
      let params = {
        pn: this.deviceInfo.pn
      }
      this.$request.get("webQueryCollectorsEs", params)
        .then((res) => {
          if (res.err == 0) {
            this.datalogger = res.dat.collector[0]
          }

        })
    },
    //单选固件包
    handleSelectionChange (selection) {
      this.selectedArrData = selection
      if (selection.length > 1) {
        this.$refs.tableRef.clearSelection();
        this.$refs.tableRef.toggleRowSelection(selection.pop());
      }
    },
    //选中行变色
    isRed ({ row }) {
      const checkIdList = this.selectedArrData.map((item) => item.id)
      if (checkIdList.includes(row.id)) {
        return {
          backgroundColor: "rgba(48,208,150,0.35)",
        }
      }
    },
    cellClass (row) {
      if (row.columnIndex === 0 && row.rowIndex === 0) {
        return 'tablemain'
      }
    },

    //最近一次升级记录查询
    getQueryCollectorFirmwareUpgradeLastRecord () {
      let params = {
        pn: this.deviceInfo.pn
      }
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeLastRecord", params).then((res) => {
        if (res.code == 0) {
          this.upgradedata = res.data
          this.upgradedata.progress = res.data.progress / 10 + "%"
        } else {
          this.upgradedata = ""
        }
      })
    },
    // 查询固件列表
    getQueryFiremware () {
      this.isLoading = true;
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", {
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      }).then((res) => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            item.size = (item.size / 1024).toFixed(1);
          });
          this.dataTable = res.data.items;
          this.isLoading = false;
        } else {
          this.dataTable = [];
          this.isLoading = false;
        }

      })
    },
    //增加固件进入界面按钮
    addFirmware () {
      this.dialogAdd = true;
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
        this.desc = null;
        this.remark = null;
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // this.$refs.upload.clearFiles()
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("createPlant.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("firmware.error1"));
        return;
      }
      this.$request.uploadfileAxios(file, this.desc, this.remark).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("createPlant.uploadSuccess"));
          // this.getData();
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("firmware.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        setTimeout(() => {
          this.getQueryFiremware();
        }, 500);
      });
    },
    //点击确定时友情提示让其上传固件文件
    warningTipButton () {
      this.$message.warning(this.$t("firmware.uploadTips"));
    },
  }
}
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.collectorUpgrade {
  width: 100%;

  .upload-input {
    display: none;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  // 上传固件弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }
  }

  /deep/.el-table tr {
    background-color: #222D35;
  }

  /deep/.el-table th.is-leaf {
    border-right: 1px solid rgba(102, 102, 102, 0.5);
    border-bottom: 1px solid rgba(102, 102, 102, 0.5);
  }

  /deep/.el-table td {
    border-right: 1px solid rgba(102, 102, 102, 0.5);
    border-bottom: 1px solid rgba(102, 102, 102, 0.5);
  }

  /deep/.el-table__body tr.hover-row td {
    background-color: transparent;
  }

  /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 0;
    background: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  /deep/ .el-table .el-table__header-wrapper .cell .el-checkbox__inner {
    display: none;
  }

  /deep/.el-table th>.cell {
    font-weight: 400;
  }

  .upgradeInfo {
    height: 136px !important;
    margin-bottom: 12px;
    box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.1);
    display: flex;
    height: 100%;

    .closepage {
      background-color: rgba(255, 255, 255, 0.05);
      width: 63px;
      height: 136px;
      background-image: url('../../../../assets/img/general/arrow_left.png');
      background-size: 24px 24px;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }

    .xinxi {
      width: 100%;
      height: 136px;
      color: #fff;
      background-color: #222D35;

      .top-info {
        display: flex;
        align-items: center;

        .label {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          height: 56px;

          // 设备状态带阴影
          .status-icon-shadow {
            width: 14px;
            height: 14px;
            border-radius: 7px;
            margin: 0 14px 0 18px;
          }

          .status-normal-shadow {
            background-color: rgba(48, 236, 112, 1);
            box-shadow: 1px 1px 3px rgba(48, 236, 112, 1);
          }

          .status-offline-shadow {
            background-color: rgba(183, 183, 183, 1);
            box-shadow: 1px 1px 3px rgba(183, 183, 183, 1);
          }

          .status-fault-shadow {
            background-color: rgba(255, 62, 62, 1);
            box-shadow: 1px 1px 3px rgba(255, 62, 62, 1);
          }

          .status-standby-shadow {
            background-color: rgba(73, 222, 255, 1);
            box-shadow: 1px 1px 3px rgba(73, 222, 255, 1);
          }

          .status-warning-shadow {
            background-color: rgba(236, 150, 48, 1);
            box-shadow: 1px 1px 3px rgba(236, 150, 48, 1);
          }
        }
      }

      .infobox {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 40px 40px;
        grid-template-areas:
          "a11 a12 a13 a14"
          "a21 a22 a23 a24"
        ;

        .gCell11 {
          grid-area: a11;
        }

        .gCell12 {
          grid-area: a12;
        }

        .gCell13 {
          grid-area: a13;
        }

        .gCell14 {
          grid-area: a14;
        }

        .gCell21 {
          grid-area: a21;
        }

        .gCell22 {
          grid-area: a22;
        }

        .gCell23 {
          grid-area: a23;
        }

        .gCell24 {
          grid-area: a24;
        }

        .cell {
          line-height: 40px;
          padding: 0px 16px;
          box-shadow: none;
          // color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          border-right: 1px solid rgba(102, 102, 102, 0.5);
        }

        .cell1 {
          line-height: 40px;
          padding: 0px 16px;
          box-shadow: none;
          // color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          // border-right: 1px solid #000;
        }

        .light {
          background: rgb(43, 56, 66);
        }

        .data {
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .dark {
          background: rgb(34, 45, 53);
        }

        .signalNew {
          justify-content: start;
          padding: 10px 0;
        }
      }
    }
  }

  .infobox1 {
    width: 100%;
    color: #fff;
    display: grid;
    grid-template-columns: 1fr 0 1fr 1fr;
    // grid-template-columns: 1fr 1fr 1fr 1fr;
    // grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    // grid-template-columns: 100px 100px 100px 100px;
    grid-template-rows: 46px 40px 48px;
    grid-template-areas:
      "b1 b1 b1 b1"
      "b11 b12 b13 b14"
      "b21 b22 b23 b24"
      "b2 b2 b2 b2"
    ;

    .bTitle1 {
      grid-area: b1;
      line-height: 46px;
      padding: 0 0 0 20px;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      background-color: #41505A;
    }

    .bTitle2 {
      margin-top: 12px;
      position: relative;
      grid-area: b2;
      line-height: 46px;
      padding: 0 0 0 20px;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      background-color: #41505A;
    }

    .bCell11 {
      grid-area: b11;
    }

    .bCell12 {
      grid-area: b12;
    }

    .bCell13 {
      grid-area: b13;
    }

    .bCell14 {
      grid-area: b14;
    }

    .bCell21 {
      grid-area: b21;
    }

    .bCell22 {
      grid-area: b22;
    }

    .bCell23 {
      grid-area: b23;
    }

    .bCell24 {
      grid-area: b24;
    }

    .cell {
      line-height: 40px;
      padding: 0px 16px;
      box-shadow: none;
      // color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      border-right: 1px solid rgba(102, 102, 102, 0.5);
    }

    .cell1 {
      line-height: 40px;
      padding: 0px 16px;
      box-shadow: none;
      // color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      // border-right: 1px solid #000;
    }

    .light {
      background: rgb(43, 56, 66);
    }

    .data {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .dark {
      background: rgb(34, 45, 53);
    }

    .todetail {
      padding: 6px 10px;
      border: 1px solid #55B491;
      border-radius: 6px;
      background-color: @primaryButtonColor;
      color: #fff;
      font-size: 14px;
      top: 7px;
      right: 20px;
      z-index: 1;
      position: absolute;
      cursor: pointer;
    }
  }

  .upgardeButtom {
    // width: 100%;
    // display: flex;
    position: relative;
    height: 60px;
    background-color: #2B3842;
    // align-items: center;
    text-align: center;

    .progressBox {
      position: absolute;
      top: 20px;
      z-index: 99;

      /deep/.el-progress__text {
        color: #ffffff;
      }
    }

    .buttonBox {
      padding: 5px 0;

      .btn-dark1 {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
        padding: 8px 66px;
        border-radius: 6px;
        height: 36px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .maskBox {
    width: 100%;
    background-color: rgba(34, 45, 53, 0.7);
    position: relative;
    height: 536px;
    left: 0px;
    top: -536px;
    z-index: 95;
  }
}
</style>